/* ======================================================================
   МОДУЛЬ: ПЛАВАЮЩИЙ ВИДЖЕТ «ПОДАРОК В TELEGRAM В 1 КЛИК»
   (Отключен: отвлекал от основного CTA воронки и снижал конверсию)
   ====================================================================== */

function initFloatingGiftWidget() {
  // Виджет полностью отключен
  return;
}